'use client';

import { c as _c } from "react/compiler-runtime";
import { useAtomValue } from 'jotai/index';
import { useEffect, useRef, useState } from 'react';
import { analyticInit, analyticSetUser, analyticWatchPath } from '@/features/analytic/enteties/analytic';
import scheduleWhenPageSettles from '@/features/analytic/utils/schedule-when-page-settles';
import { loggedUserAtom } from '@/features/user/atoms/logged-user-atom';
import { usePathname } from '@/i18n/routing';

// Need to be in each page and set new pathname to Google analytic
export default function GoogleAnalyticInit() {
  const $ = _c(13);
  const loggedUser = useAtomValue(loggedUserAtom);
  const oldPathRef = useRef("");
  const pathname = usePathname();
  const [isReady, setIsReady] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const landing = {
        href: globalThis.location.href,
        referrer: document.referrer
      };
      let isCancelled = false;
      scheduleWhenPageSettles(() => {
        if (isCancelled) {
          return;
        }
        analyticInit(landing);
        setIsReady(true);
      });
      return () => {
        isCancelled = true;
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] !== isReady || $[3] !== loggedUser) {
    t2 = () => {
      if (!isReady) {
        return;
      }
      analyticSetUser(loggedUser ? loggedUser.id : null);
    };
    t3 = [isReady, loggedUser];
    $[2] = isReady;
    $[3] = loggedUser;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== isReady || $[7] !== pathname) {
    t4 = () => {
      if (!isReady) {
        return;
      }
      if (oldPathRef.current !== pathname) {
        oldPathRef.current = pathname;
        analyticWatchPath(pathname);
      }
    };
    $[6] = isReady;
    $[7] = pathname;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isReady || $[10] !== loggedUser || $[11] !== pathname) {
    t5 = [isReady, loggedUser, pathname];
    $[9] = isReady;
    $[10] = loggedUser;
    $[11] = pathname;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  return null;
}